import React from 'react';
import i18next from 'i18next';
import clsx from 'clsx';
import queryString from 'query-string';
import { withRouter } from 'react-router-dom';

import { withStyles } from '@material-ui/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import { popTabList } from 'constants/resources/commonCustomize';

import TabPanel from './TabPanel';

const styles = (theme) => ({
  tabsRoot: {
    marginBottom: '-1px',
    height: 48,
    '&.isModal': { backgroundColor: '#e5e8eb', borderRadius: '4px' },
    '&.hide': { display: 'none' },
  },
  indicator: {
    backgroundColor: theme.palette.primary.deep,
    '.normal &': { top: 0 },
    '.isModal &': { height: '100%', background: '#8d9ba2', opacity: 0.5 },
  },
  tabRoot: {
    padding: '5px 10px',
    borderRadius: '4px 4px 0 0',
    opacity: 1,
    transitionDuration: '0.3s',
    fontSize: 14,
    borderBottom: '2px solid #e5e8eb',
    fontWeight: 500,
    color: theme.palette.common.black,
    '.normal &': {
      color: '#9b9ca4',
      marginRight: '4px',
      backgroundColor: '#f9fafb',
      border: 'solid 1px #e5e8eb',
    },
    minWidth: 100,
    '&.isModal': {
      flex: '1 1 100px',
      marginRight: 0,
      backgroundColor: 'transparent',
      borderRadius: 0,
    },
  },
  flexContainer: { height: '100%' },
  selected: {
    backgroundColor: `${theme.palette.common.white} !important`,
    borderRadius: 0,
    borderBottom: `0 !important`,
    fontWeight: 500,
    color: `${theme.palette.common.black} !important`,
  },
});

function a11yProps(name, key) {
  return {
    id: `${name}-tab-${key}`,
    'aria-controls': `${name}-tabpanel-${key}`,
  };
}

function makeTabs({
  name,
  tabMenuList = new Map(),
  tabs,
  classes,
  value,
  isModal,
  popoverTab,
  location,
}) {
  // 탭 메뉴
  const tabArray = [];
  // 탭 내용
  // const tabPanelArray = [];
  let tabPanelArray = [];
  let tabIndex = -1;
  let { isPop, popGroup, isFrame, isEmbed } = queryString.parse(
    window.location.search
  );

  let newValue;
  if (value.indexOf('?') > -1) {
    newValue = value.substring(0, value.indexOf('?'));
  } else {
    newValue = value;
  }

  /**
   * 멀티텝 팝업
   */
  if (
    name !== 'mb-daily-statistics-display-popper' &&
    name !== 'displayFilter' &&
    (isPop || isFrame || isEmbed) &&
    typeof popTabList[popGroup] !== 'undefined'
  ) {
    for (let popTab in popTabList[popGroup]) {
      let menuNm = popTabList[popGroup][popTab].value.menuNm;
      let menuUrl = popTabList[popGroup][popTab].key;

      if (typeof popGroup !== 'undefined') {
        tabArray.push(
          <Tab
            key={menuNm}
            value={menuUrl}
            classes={{ root: classes.tabRoot, selected: classes.selected }}
            className={clsx({ isModal })}
            label={menuNm}
            {...a11yProps(name, menuNm)}
          />
        );
      }

      tabIndex++;
      if (newValue === menuUrl) {
        tabPanelArray[tabIndex] = (
          <TabPanel
            value={newValue}
            keyValue={menuUrl}
            key={menuUrl}
            name={name}
            isModal={isModal}
            popoverTab={popoverTab}
          >
            <React.Fragment key={menuUrl}>
              {typeof tabs[menuUrl] === 'undefined'
                ? i18next.t('관리자에게 문의하세요.')
                : tabs[menuUrl].tabComponent}
            </React.Fragment>
          </TabPanel>
        );
      }
    }
  } else {
    /**
     * 일반페이지텝 (프레임일때도 쓰임)
     */
    for (let tabMenu of tabMenuList.values()) {
      const { menuUrl, menuSeq, menuNm } = tabMenu;
      //팝업제어를 위해 추가
      if (
        typeof tabs[menuUrl] !== 'undefined' &&
        typeof tabs[menuUrl].isPop === 'undefined' &&
        typeof tabs[menuUrl].isEmbed === 'undefined'
      ) {
        if (
          typeof popGroup === 'undefined' ||
          name === 'mb-daily-statistics-display-popper'
        ) {
          tabArray.push(
            <Tab
              key={menuSeq}
              value={menuUrl}
              classes={{ root: classes.tabRoot, selected: classes.selected }}
              className={clsx({ isModal })}
              label={menuNm}
              {...a11yProps(name, menuSeq)}
            />
          );
        }
      }

      tabIndex++;

      if (value === menuUrl || newValue === menuUrl) {
        tabPanelArray[tabIndex] = (
          <TabPanel
            value={menuUrl}
            keyValue={menuUrl}
            key={menuUrl}
            name={name}
            isModal={isModal}
            popoverTab={popoverTab}
          >
            <React.Fragment key={menuUrl}>
              {typeof tabs[menuUrl] === 'undefined'
                ? i18next.t('관리자에게 문의하세요.')
                : tabs[menuUrl].tabComponent}
            </React.Fragment>
          </TabPanel>
        );
      }
    }
  }

  return [tabArray, tabPanelArray, popGroup];
}

function initSetting(props, state, valueSet) {
  const {
    history,
    match,
    location,
    tabMenuList,
    name,
    tabs,
    classes,
    isModal,
    changeUrl = true,
    popoverTab,
  } = props;
  let { value } = state;
  let url = null;

  if (valueSet) {
    if (match.path === value && window.location.search === '') {
      // 사이드바에서 해당메뉴 클릭해서 들어온 경우
      value = tabMenuList.keys().next().value;
      url = value;
    } else {
      let tempCnt = 0;
      if (value.lastIndexOf('/') + 1 === value.length) {
        // url 마지막에 / 추가된 경우
        value = value.slice(0, value.lastIndexOf('/'));
      }

      for (let path of tabMenuList.keys()) {
        if (value === path) {
          break;
        } else {
          tempCnt++;
        }
      }
      if (tabMenuList.size === tempCnt) {
        // 일치하는 tab 없음 404
        url = '/404';
      }
    }

    if (changeUrl && url !== null) {
      history.push(url);
    }
  }

  const [tabArray, tabPanelArray] = makeTabs({
    name,
    tabMenuList,
    tabs,
    classes,
    value,
    isModal,
    popoverTab,
    location,
  });

  return {
    value,
    tabArray,
    tabPanelArray,
  };
}

export default withRouter(
  withStyles(styles)(
    class MbTabs extends React.Component {
      constructor(props) {
        super(props);
        const {
          location,
          tabMenuList,
          isModal,
          initValue,
          getCurTab = (f) => f,
        } = props;

        let value =
          typeof initValue === 'undefined' ? location.pathname : initValue;

        const { isPop, popGroup, isFrame, isEmbed } = queryString.parse(
          window.location.search
        );
        getCurTab(value);
        this.state = {
          ...this.state,
          ...initSetting(
            props,
            { value },
            typeof tabMenuList !== 'undefined' && !isModal
          ),
          isPop,
          popGroup,
          isFrame,
          isEmbed,
        };
      }

      componentDidUpdate(prevProps) {
        const { tabMenuList: prevTabMenuList } = prevProps;
        const { tabMenuList } = this.props;
        let valueSet = false;
        if (prevTabMenuList !== tabMenuList) {
          if (typeof prevTabMenuList === 'undefined') {
            // list 없다가 받아온경우 (map size 다를때)
            valueSet = true;
          }

          this.setState({
            ...this.state,
            ...initSetting(this.props, this.state, valueSet),
          });
        }
      }

      handleChange = (event, newValue) => {
        //이미지검수 tab 변화없게 만듬...개선이 필요
        if (newValue === '/mobsense/admin/rtb/kakao_banner.php') {
          window.open('http://mobon.net' + newValue);
        } else {
          const {
            history,
            tabMenuList,
            name,
            tabs,
            classes,
            isModal = false,
            changeUrl = true,
            popoverTab,
            getCurTab = (f) => f,
            location,
          } = this.props;
          let oldValue = newValue;
          const { isPop, isEmbed, isFrame } = queryString.parse(
            window.location.search
          );
          getCurTab(newValue);
          if (newValue === null) {
            // tab url 이 null 인 경우
          } else {
            getCurTab(newValue);
            if (!isModal && changeUrl) {
              let q = queryString.parse(window.location.search);
              let k = 0;
              let qStr = '';
              for (let qParam in q) {
                if (qParam !== 'uri') {
                  if (k === 0) {
                    qStr = '?' + qParam + '=' + q[qParam];
                  } else {
                    qStr += '&' + qParam + '=' + q[qParam];
                  }
                } else {
                  qStr += '&uri=' + newValue;
                }
                k++;
              }
              if (isPop || isEmbed || isFrame) {
                newValue = newValue + qStr;
              }

              history.push(newValue);
            }

            const [tabArray, tabPanelArray] = makeTabs({
              name,
              tabMenuList,
              tabs,
              classes,
              value: newValue,
              isModal,
              popoverTab,
              location,
            });

            this.setState({
              ...this.state,
              tabArray,
              tabPanelArray,
              value: oldValue,
              isModal,
            });
          }
        }
      };

      render() {
        const { handleChange } = this;
        const {
          classes,
          isModal,
          name,
          popoverTab = false,
          isMenuTab = true,
        } = this.props;
        const {
          isPop,
          isFrame,
          isEmbed,
          popGroup,
          value,
          tabArray,
          tabPanelArray,
        } = this.state;
        let isPopFlag;

        //싱글텝팝업 (텝없음)
        if (
          (Number(isPop) === 1 || Number(isEmbed) === 1) &&
          typeof popGroup === 'undefined'
        ) {
          isPopFlag = true;

          //멀티텝팝업 (텝있음)
        } else if (
          (Number(isPop) === 1 || Number(isEmbed) === 1) &&
          typeof popGroup !== 'undefined'
        ) {
          isPopFlag = false;

          //isFrame 텝전체 나오게할경우 (텝있음)
        } else if (Number(isFrame) === 1 && typeof popGroup === 'undefined') {
          isPopFlag = false;
        } else {
          isPopFlag = false;
        }

        return (
          <>
            <Tabs
              className={clsx({
                isModal,
                normal: !popoverTab,
                hide: isPopFlag && isMenuTab,
              })}
              classes={{
                root: classes.tabsRoot,
                flexContainer: classes.flexContainer,
                indicator: classes.indicator,
              }}
              value={value}
              onChange={handleChange}
              aria-label={name}
              variant="scrollable"
              scrollButtons="off"
            >
              {tabArray}
            </Tabs>
            {tabPanelArray}
          </>
        );
      }
    }
  )
);
